export const TEST_ID = 'mapHorizontalControlBar';
